import AxiosAPI from '../../../utils/AxiosAPI';

export function handelLoadTrans(authInfo, transType, dateStart, dateEnd, currency) {
    return new Promise((resolve, reject) => {
        AxiosAPI(authInfo)
            .setPath(`/api/finance/transactions/tran/`, { transType, dateStart, dateEnd, currency })
            .get()
            .then(({ data }) => {
                if (data.error === 0) {
                    resolve(data);
                } else {
                    reject(Error(data.message));
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export default null;
